module.exports = __webpack_public_path__ + "3ac5bc4d67eed8c5b7752762f257fe84.svg";